import { render, staticRenderFns } from "./PsPatientWeekend.vue?vue&type=template&id=c3a1e0ca&scoped=true&"
import script from "./PsPatientWeekend.vue?vue&type=script&lang=js&"
export * from "./PsPatientWeekend.vue?vue&type=script&lang=js&"
import style0 from "./PsPatientWeekend.vue?vue&type=style&index=0&id=c3a1e0ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a1e0ca",
  null
  
)

export default component.exports